var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayinline = function SvgPlayinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#181A1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 24 20 14v20l14-10Z",
    fill: "#fff"
  })));
};
export default SvgPlayinline;